import { Injectable } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { RestApi } from "src/app/shared/RestApi/restApi";
import { MatSnackBar } from "@angular/material/snack-bar";

// interface UsersServiceInfo {
//   statusMessage: any;
//   error: boolean;
//   data: any;

// }

@Injectable({
  providedIn: 'root'
})
export class objectPopupScreenService {

    selectedValueForIsparent;



  private headers = new HttpHeaders({ "Content-Type": "application/json" });

  constructor(private spinner: NgxUiLoaderService, private http: HttpClient, private restAPI: RestApi, private snackBar: MatSnackBar) { }

  setValueSelectedValueForIsparent(value){
       this.selectedValueForIsparent=value;
  }

}